var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddWhitePlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "url(#paint0_linear_421_10042)",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6874 12.4303H14.235V8.97788C14.235 8.50144 13.8492 8.11475 13.3718 8.11475C12.8945 8.11475 12.5087 8.50144 12.5087 8.97788V12.4303H9.05625C8.57894 12.4303 8.19312 12.817 8.19312 13.2935C8.19312 13.7699 8.57894 14.1566 9.05625 14.1566H12.5087V17.6091C12.5087 18.0855 12.8945 18.4722 13.3718 18.4722C13.8492 18.4722 14.235 18.0855 14.235 17.6091V14.1566H17.6874C18.1648 14.1566 18.5506 13.7699 18.5506 13.2935C18.5506 12.817 18.1648 12.4303 17.6874 12.4303Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_421_10042",
    x1: 5.43685,
    y1: 6.6023,
    x2: 31.9226,
    y2: 16.8114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E4C97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWhitePlusIcon);
export default __webpack_public_path__ + "static/media/add-white-plus-icon.daae8b440b513ba88f87428242f2fa49.svg";
export { ForwardRef as ReactComponent };